
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AdditionalBillingProfileResource,
  CreateAdditionalBillingProfileRequest,
  UpdateAdditionalBillingProfileRequest,
  ValidationError,
} from '../models';
import {
    AdditionalBillingProfileResourceFromJSON,
    AdditionalBillingProfileResourceToJSON,
    CreateAdditionalBillingProfileRequestFromJSON,
    CreateAdditionalBillingProfileRequestToJSON,
    UpdateAdditionalBillingProfileRequestFromJSON,
    UpdateAdditionalBillingProfileRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface CreateAdditionalBillingProfileOperationRequest {
    legalEntityId: string;
    createAdditionalBillingProfileRequest: CreateAdditionalBillingProfileRequest;
}

export interface DeleteAdditionalBillingProfileRequest {
    legalEntityId: string;
    additionalBillingProfileId: string;
}

export interface GetAdditionalBillingProfilesRequest {
    legalEntityId: string;
}

export interface UpdateAdditionalBillingProfileOperationRequest {
    legalEntityId: string;
    additionalBillingProfileId: string;
    updateAdditionalBillingProfileRequest: UpdateAdditionalBillingProfileRequest;
}

/**
 * 
 */
export class ClientLegalEntityAdditionalBillingProfileApi extends runtime.BaseAPI {

    /**
     * Create an additional billing profile for a legal entity
          */
    async createAdditionalBillingProfileRaw(requestParameters: CreateAdditionalBillingProfileOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdditionalBillingProfileResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling createAdditionalBillingProfile().'
            );
        }

        if (requestParameters['createAdditionalBillingProfileRequest'] == null) {
            throw new runtime.RequiredError(
                'createAdditionalBillingProfileRequest',
                'Required parameter "createAdditionalBillingProfileRequest" was null or undefined when calling createAdditionalBillingProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AdditionalBillingProfileResource>({
            path: `/compliance/api/legal-entities/{legalEntityId}/additional-billing-profiles`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAdditionalBillingProfileRequestToJSON(requestParameters['createAdditionalBillingProfileRequest']),
        }, initOverrides);

        if (response._data) { response._data=AdditionalBillingProfileResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create an additional billing profile for a legal entity
          */
    async createAdditionalBillingProfile(requestParameters: CreateAdditionalBillingProfileOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdditionalBillingProfileResource> {
        const response = await this.createAdditionalBillingProfileRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Delete an additional billing profile
          */
    async deleteAdditionalBillingProfileRaw(requestParameters: DeleteAdditionalBillingProfileRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling deleteAdditionalBillingProfile().'
            );
        }

        if (requestParameters['additionalBillingProfileId'] == null) {
            throw new runtime.RequiredError(
                'additionalBillingProfileId',
                'Required parameter "additionalBillingProfileId" was null or undefined when calling deleteAdditionalBillingProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/legal-entities/{legalEntityId}/additional-billing-profiles/{additionalBillingProfileId}`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))).replace(`{${"additionalBillingProfileId"}}`, encodeURIComponent(String(requestParameters['additionalBillingProfileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete an additional billing profile
          */
    async deleteAdditionalBillingProfile(requestParameters: DeleteAdditionalBillingProfileRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdditionalBillingProfileRaw(requestParameters, initOverrides);
    }

    /**
     * Get all additional billing profiles for a legal entity
          */
    async getAdditionalBillingProfilesRaw(requestParameters: GetAdditionalBillingProfilesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<AdditionalBillingProfileResource>>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling getAdditionalBillingProfiles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<AdditionalBillingProfileResource>>({
            path: `/compliance/api/legal-entities/{legalEntityId}/additional-billing-profiles`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(AdditionalBillingProfileResourceFromJSON);
        return response;
    }

    /**
     * Get all additional billing profiles for a legal entity
          */
    async getAdditionalBillingProfiles(requestParameters: GetAdditionalBillingProfilesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<AdditionalBillingProfileResource>> {
        const response = await this.getAdditionalBillingProfilesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update an additional billing profile
          */
    async updateAdditionalBillingProfileRaw(requestParameters: UpdateAdditionalBillingProfileOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdditionalBillingProfileResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling updateAdditionalBillingProfile().'
            );
        }

        if (requestParameters['additionalBillingProfileId'] == null) {
            throw new runtime.RequiredError(
                'additionalBillingProfileId',
                'Required parameter "additionalBillingProfileId" was null or undefined when calling updateAdditionalBillingProfile().'
            );
        }

        if (requestParameters['updateAdditionalBillingProfileRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAdditionalBillingProfileRequest',
                'Required parameter "updateAdditionalBillingProfileRequest" was null or undefined when calling updateAdditionalBillingProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AdditionalBillingProfileResource>({
            path: `/compliance/api/legal-entities/{legalEntityId}/additional-billing-profiles/{additionalBillingProfileId}`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))).replace(`{${"additionalBillingProfileId"}}`, encodeURIComponent(String(requestParameters['additionalBillingProfileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAdditionalBillingProfileRequestToJSON(requestParameters['updateAdditionalBillingProfileRequest']),
        }, initOverrides);

        if (response._data) { response._data=AdditionalBillingProfileResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update an additional billing profile
          */
    async updateAdditionalBillingProfile(requestParameters: UpdateAdditionalBillingProfileOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdditionalBillingProfileResource> {
        const response = await this.updateAdditionalBillingProfileRaw(requestParameters, initOverrides);
        return response._data;
    }

}
